import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import {
  Box,
  Dialog,
  DialogContent,
  Button,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
} from "@mui/material";
import { PrimaryDialogTitle } from "../Dialog/DialogComponents";
import {
  START_PAYMENT_CREATE,
  CLEAR_SUBSCRIPTION_CREATE,
} from "Actions/HomeAction";
import { connect, useDispatch } from "react-redux";
import { useNotification } from "Hooks/NotificationManager";
import { START_GET_LOGIN_USER } from "Actions/UserAction";
import Payment from "./Payment";
const useStyle = makeStyles((theme) => ({
  rsDialogMainRoot: {
    margin: "20px",

    "& .MuiPaper-root.MuiPaper-elevation": {
      position: "absolute",
      top: "5% !important",
      padding: "20px",
      // transform: "translate(-50%, -50%)", // This centers the dialog
      borderRadius: "15px",
      maxWidth: "450px !important",
      "@media (max-height: 785px)": {
        top: "-20px !important",
      },
      "@media (max-height: 700px)": {
        top: "-30px !important",
        padding: "none !important",
      },
      [theme.breakpoints.down("1599")]: {
        maxWidth: "450px !important",
      },
      [theme.breakpoints.down("1300")]: {
        maxWidth: "450px !important",
      },
      [theme.breakpoints.down("930")]: {
        maxWidth: "450px !important",
      },
      [theme.breakpoints.down("786")]: {
        maxWidth: "450px !important",
      },
      [theme.breakpoints.down("650")]: {
        maxWidth: "450px !important",
        maxHeight: "675px !important",
      },
      [theme.breakpoints.down("550")]: {
        maxWidth: "450px !important",
      },
      [theme.breakpoints.down("395")]: {
        maxWidth: "460px !important",
      },
      [theme.breakpoints.down("380")]: {
        maxWidth: "460px !important",
        maxHeight: "650px !important",
        padding: "none !important",
      },
      [theme.breakpoints.down("370")]: {
        padding: "20px 10px !important",
      },
      [theme.breakpoints.down("350")]: {
        padding: "20px 5px !important",
      },
    },
  },

  csConfirmationBox: {
    "&>div": {
      padding: "0px 0px 20px 0px !important",
      "&>div": {
        "&>h3": {
          marginTop: "30px !important",
        },
      },
      "&>h4": {
        marginTop: "25px",
      },
    },
  },

  csMainTitle: {
    "&>h2": {
      "&>p": {
        fontSize: "10px !important",
      },
    },
  },
  Header: {
    "&>div": {
      "&>h2": {
        fontSize: "16px !important",
        "&>p": {
          marginTop: "15px",
          marginBottom: "-10px",
          color: "black !important",
          fontSize: "22px !important",
          [theme.breakpoints.down("470")]: {
            fontSize: "18px !important",
          },
          [theme.breakpoints.down("380")]: {
            fontSize: "16px !important",
            marginLeft: "-5px",
          },
        },
      },
    },
  },
  form: {
    overflowX: "hidden",
    padding: "10px",
  },
  durationBox: {
    paddingLeft: "10px",
    paddingRight: "10px",
    // paddingTop: "30px",
    // width: "410px",
    // [theme.breakpoints.down("450")]: {
    //   maxWidth: "290px !important",
    // },
    // [theme.breakpoints.down("380")]: {
    //   maxWidth: "280px !important",
    // },
    "&>div": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      border: "2px solid #EECA3C",
      borderRadius: "16px",
      padding: "10px",
      background: "#FFFDF3",

      "&>div": {
        padding: "5px",

        "&>h6": {
          fontWeight: "400 ",
          fontSize: "15px",
          [theme.breakpoints.down("470")]: {},
          [theme.breakpoints.down("450")]: {
            fontSize: "11px !important",
          },
          [theme.breakpoints.down("336")]: {
            fontSize: "9px !important",
          },

          "&>span": {
            color: "rgba(80, 80, 80, 0.6) !important",
          },
        },
        "&>h5": {
          fontWeight: "600 !important",
          fontSize: "18px",
          [theme.breakpoints.down("470")]: {
            fontSize: "15px !important",
          },
          [theme.breakpoints.down("450")]: {
            fontSize: "12px !important",
          },
          [theme.breakpoints.down("336")]: {
            fontSize: "11px !important",
          },
        },
      },
    },
  },
  durationBox2: {
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: "10px",
    // width: "410px",
    // [theme.breakpoints.down("450")]: {
    //   maxWidth: "290px !important",
    // },
    // [theme.breakpoints.down("380")]: {
    //   maxWidth: "280px !important",
    // },
    "&>div": {
      marginTop: "10px",
      alignItems: "baseline",
      border: "2px solid #EECA3C",
      borderRadius: "16px",
      background: "#FFFDF3",
      padding: "10px",

      "&>div": {
        padding: "5px",
        "&>div": {
          "&>div": {
            display: "flex",
            justifyContent: "space-between",
            "&>h6": {
              fontWeight: "400 ",
              fontSize: "18px",
              marginTop: "3px",
              [theme.breakpoints.down("470")]: {
                fontSize: "15px !important",
              },
              [theme.breakpoints.down("450")]: {
                fontSize: "14px !important",
              },
              "&>span": {
                color: "rgba(80, 80, 80, 0.6) !important",
              },
            },

            "&>h5": {
              fontWeight: "600 !important",
              fontSize: "18px",
              [theme.breakpoints.down("470")]: {
                fontSize: "15px !important",
              },
              [theme.breakpoints.down("450")]: {
                fontSize: "14px !important",
              },
            },
            "&>hr": {
              opacity: "0.8",
              marginBottom: "20px",
              borderColor: "rgba(80, 80, 80, 0.1) !important",
            },
            "&>h3": {
              fontWeight: "500",
              fontSize: "24px",
              [theme.breakpoints.down("470")]: {
                fontSize: "20px !important",
              },
              [theme.breakpoints.down("450")]: {
                fontSize: "18px !important",
              },
              [theme.breakpoints.down("336")]: {
                fontSize: "15px !important",
              },
            },
            "&>h4": {
              color: "#7BC044",
              fontWeight: "700",
              fontSize: "24px",
              [theme.breakpoints.down("470")]: {
                fontSize: "20px !important",
              },
              [theme.breakpoints.down("450")]: {
                fontSize: "18px !important",
              },
              [theme.breakpoints.down("336")]: {
                fontSize: "15px !important",
              },
            },
            "&>span": {
              "&>hr": {
                opacity: "0.8",
                marginTop: "8px",
                marginBottom: "5px",
                border: "2px Dotted black !imporatant",
                // borderColor: "rgba(80, 80, 80, 0.1) !important",
              },
            },
          },
        },
      },
    },
  },
  form: {
    overflowX: "hidden",
    padding: "10px",
  },
}));

const PaymentMain = (props) => {
  const {
    open,
    duration,
    setOpen,
    paymentCreate,
    getLoginUserAction,
    subscriptionCreate,
  } = props;

  const classes = useStyle();
  const notification = useNotification();
  const [cardError, setCardError] = useState("");
  const dispatch = useDispatch();
  const [apiResult, setApiResult] = useState(false);
  const handleClose = () => {
    setOpen(false);
    dispatch({ type: CLEAR_SUBSCRIPTION_CREATE });
  };

  const stripePromise = loadStripe(process.env.REACT_APP_PAYMENT_PUBLIC_KEY);

  const options = {
    clientSecret: subscriptionCreate?.data?.data?.client_secret,
  };

  useEffect(() => {
    if (paymentCreate?.data?.success) {
      handleClose();
      // getLoginUserAction();
      setTimeout(() => {
        getLoginUserAction();
      }, 3000);
    }
  }, [paymentCreate?.data?.success]);

  useEffect(() => {
    if (apiResult !== false) {
      setTimeout(() => {
        getLoginUserAction();
      }, 1000);
    }
  }, [apiResult]);

  useEffect(() => {
    if (paymentCreate?.error) {
      notification.error(paymentCreate?.error.message);
    }
  }, [paymentCreate?.error]);

  const CheckoutForm = () => {
    return (
      <Payment
        cardError={cardError}
        setCardError={setCardError}
        options={options}
        getLoginUserAction={getLoginUserAction}
        setOpen={setOpen}
        apiResult={apiResult}
        setApiResult={setApiResult}
      />
    );
  };

  return (
    <Dialog
      open={open}
      className={classes.rsDialogMainRoot}
      onClose={(e) => {
        if (e.key === "Escape") {
          handleClose();
        }
      }}
      BackdropProps={{
        classes: {
          root: "root",
        },
      }}
    >
      <Box className={classes.csMainTitle}>
        <Box className={classes.Header}>
          <PrimaryDialogTitle
            handleClose={handleClose}
            title={"Please complete your payment"}
          />
        </Box>
      </Box>
      <Box className={classes.csConfirmationBox}>
        <DialogContent>
          <Grid className={classes.durationBox}>
            <Box>
              <Box>
                <h6>Plan Duration</h6>
                <h5>{duration == "6 month" ? `6 Months` : `1 Year`}</h5>
              </Box>
              <Box>
                <h6>Unit Price</h6>
                <h5>
                  {duration == "6 month" ? `£23.00 /` : `£20/`}
                  <span>month</span>
                </h5>
              </Box>
              <Box>
                <h6 style={{ fontWeight: "600" }}>Subtotal</h6>
                <h5 style={{ float: "right" }}>
                  {duration == "6 month" ? `£138.00` : `£240.00`}
                </h5>
              </Box>
            </Box>
          </Grid>
          <Grid className={classes.durationBox2}>
            <Box>
              <Box>
                <Box>
                  <Box style={{ marginTop: "-5px" }}>
                    <h6>Subtotal</h6>
                    <h5>{duration == "6 month" ? `£138.00` : `£240.00`}</h5>
                  </Box>
                  <Box>
                    <h6>VAT(20%)</h6>
                    <h5>{duration == "6 month" ? `£27.60` : `£48.00`}</h5>
                  </Box>

                  <span>
                    <hr
                      style={{
                        border: "1px Dashed #969591",
                        marginTop: "15px",
                        marginBottom: "10px",
                      }}
                    />
                  </span>
                  <Box>
                    <h3>Payable Amount</h3>
                    <h4>{duration == "6 month" ? `£165.60` : `£288.00`}</h4>
                  </Box>
                  <span>
                    <hr
                      className={classes.border02}
                      style={{
                        border: "1px Dashed #969591",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    />
                  </span>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Elements stripe={stripePromise} options={options}>
            <CheckoutForm />
          </Elements>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  paymentCreate: state.home.paymentCreate,
  subscriptionCreate: state.home.subscriptionCreate,
});

const mapDispatchToProps = (dispatch) => ({
  paymentCreateAction: (payload) =>
    dispatch({ type: START_PAYMENT_CREATE, payload }),
  getLoginUserAction: () => dispatch({ type: START_GET_LOGIN_USER }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMain);
